import { Injectable } from '@angular/core';
import { Carrinho } from '../persistences/carrinho';
import { PedidoVenda } from '../persistences/pedido-venda';
import { Config } from './../persistences/config';
import { Cliente } from './../persistences/cliente';
import { IsTabelaSelecionadaItem } from '../persistences/is-tabela-selecionada-item';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageSingletonService {

    constructor() {        
      console.log("Reconstruiu LocalStorageSingletonService");
    }

    private setarItem(chave: string, valor: any): void{
      localStorage.setItem(chave, JSON.stringify(valor));
    }

    private buscarItem<T>(chave: string): T | null {
      const item = localStorage.getItem(chave);
      return item ? JSON.parse(item) : null;
    }

    /*Nao sei porque, mas alguns objetos mesmo com o buscarItem forçando parse, ainda precisou garantir novamente*/
    private forceParse(json: any): any {
      if (typeof json === 'string') {
        json = JSON.parse(json);
      } 
      return json;
    }
    
    atualizarCarrinho(carrinho : Carrinho): void {
      this.setarItem("carrinho", JSON.stringify(carrinho));
    }    
    
    atualizarPedido(pedidoVenda : PedidoVenda): void {
      this.setarItem("pedidoVenda", JSON.stringify(pedidoVenda));
    }           

    atualizarConfig(config : Config): void {
      this.setarItem("config_business", JSON.stringify(config));
    }

    atualizarCliente(cliente: Cliente): void {
      this.setarItem("cliente_business", JSON.stringify(cliente));
    }

    atualizarIsTabelaSelecionadaItem(isTabelaSelecionadaItem: IsTabelaSelecionadaItem): void {
      this.setarItem("is_tabela_selecionada_item_"+isTabelaSelecionadaItem.getIdItem, JSON.stringify(isTabelaSelecionadaItem));
    }

    buscarCliente():Cliente {
      return new Cliente(this.forceParse(this.buscarItem("cliente_business")));
    }
    
    buscarCarrinho(): Carrinho {     
      return new Carrinho(this.forceParse(this.buscarItem("carrinho"))); 
    }

    buscarPedido(): PedidoVenda {
      return new PedidoVenda(this.forceParse(this.buscarItem("pedidoVenda")));
    }

    buscarConfig(): Config {      
      return new Config(this.forceParse(this.buscarItem("config_business")));
    }

    buscarIsTabelaSelecionadaItem(idItem: number): IsTabelaSelecionadaItem {      
      return new IsTabelaSelecionadaItem(this.forceParse(this.buscarItem("is_tabela_selecionada_item_"+idItem)));
    }

    buscarLoginEmAndamento(){
      return this.buscarItem("login_em_andamento");
    }

    /** Layout (1 Lista, 2 Cards, 3 Tabela) escolhido pelo usuário. Fica em localStorage: sobrevive ao F5 e ao fechar o navegador, mas é descartada no login (volta ao LAYOUT_EXIBICAO) e no logout (limparStorage). */
    buscarLayoutEscolhido(): number | null {
      const valor = Number(localStorage.getItem("layout_escolhido_business"));
      return valor >= 1 && valor <= 3 ? valor : null;
    }

    atualizarLayoutEscolhido(layout: number): void {
      localStorage.setItem("layout_escolhido_business", String(layout));
    }

    limparLayoutEscolhido(): void {
      localStorage.removeItem("layout_escolhido_business");
    }

    /** Preferência da visualização Tabela: expandir automaticamente a linha ao navegar pelas setas (padrão: ligada). */
    buscarTabelaExpandirAoNavegar(): boolean {
      const valor = this.buscarItem<boolean>("tabela_expandir_ao_navegar");
      return valor === null ? true : valor === true;
    }

    atualizarTabelaExpandirAoNavegar(valor: boolean): void {
      this.setarItem("tabela_expandir_ao_navegar", valor);
    }

    limparStorage(): void {
      localStorage.clear();
    }

}
